import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class Municipis {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/municipis/`;
  private municipis: any[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<any[]> {
    return this.$http.get(`${this.apiurl}findAll?`)
      .then((response: any) => {
        this.municipis = response.data.municipis;
        return this.municipis;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }

  getMunicipis(paramsMun: any): ng.IPromise<any[]> {
    const requestParams = { ...paramsMun }; // Merging parameters
    return this.$http.get(`${this.apiurl}find?`, { params: requestParams })
      .then((response: any) => {
        this.municipis = response.data.municipis;
        return this.municipis;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }

  setMunicipisParams(paramsArray: any[], paramsMun: any): any {
    paramsArray.forEach((param: any) => {
      paramsMun = this.copy(paramsMun, param);
    });
    return paramsMun;
  }

  copy(dest, source) {
    if (typeof source === "object") {
      (Object.entries(source) || []).forEach(([key, value]) => {
        if (dest.hasOwnProperty(key)) {
          dest[key] = value;
        }
      });
    }
    return dest;
  }
}

angularJsApp.service(AppServicesEnum.MUNICIPIS_SERVICE, Municipis);
